<script>
import MemberService from '../../js/service/MemberService';

export default {
    methods: {
        urlForMember(memberId) {
            return `/backend/clubs/members/${memberId}/show`;
        },
        urlForMemberEdit(memberId) {
            return `/backend/clubs/members/${memberId}/edit/basicData`;
        },
        urlForMemberContracts(memberId) {
            return `/backend/clubs/members/${memberId}/edit/contractData`;
        },
        avatarUrl(memberId, hasAvatar, gender, fileName) {
            return MemberService.avatarUrl(memberId, hasAvatar, gender, 'avatar', fileName);
        },
    },
}
</script>
